const CLIENT_ID = 2;

function buildApexBoxingPlan(clientId, items) {
  if (Number(clientId) !== CLIENT_ID) return { status: 'not-applicable' };
  const singleBoxItemIds = items.filter(item =>
    Number(item.cl_id) === CLIENT_ID &&
    Number(item.apex_oversize) === 1 &&
    Number(item.oi_qty) > 0
  ).map(item => String(item.oi_id)).sort();
  return { status: items.length ? 'ready' : 'empty', singleBoxItemIds };
}

module.exports = { buildApexBoxingPlan };

/* Legacy EAN/volume boxing rules, retained for possible reinstatement.
const VOLUME_LIMIT = 17280;
const MAX_UNITS = 10000;

function buildApexBoxingPlan(clientId, items) {
  if (Number(clientId) !== CLIENT_ID) return { status: 'not-applicable' };
  if (!items.length) return { status: 'empty', boxes: [], assignments: {} };

  const issues = [];
  const units = [];
  const seen = new Set();
  let total = 0;
  items.forEach(item => {
    const label = item.pr_sku || `Item ${item.oi_id}`;
    const quantity = Number(item.oi_qty);
    const key = String(item.oi_id);
    if (Number(item.cl_id) !== CLIENT_ID || !item.oi_id || seen.has(key)) {
      issues.push(`${label}: order item data is inconsistent; refresh the order.`);
      return;
    }
    seen.add(key);
    if (item.oi_qty == null || String(item.oi_qty).trim() === '' ||
        !Number.isSafeInteger(quantity) || quantity < 0) {
      issues.push(`${label}: invalid wheel quantity.`);
      return;
    }
    if (quantity === 0) return;
    total += quantity;
    if (total > MAX_UNITS) {
      issues.push(`Packing plans support up to ${MAX_UNITS} wheels; review this order manually.`);
      return;
    }
    const raw = String(item.pr_ean == null ? '' : item.pr_ean).trim();
    const volume = Number(raw);
    if (!/^\d+(\.\d+)?$/.test(raw) || !Number.isFinite(volume) || volume <= 0) {
      issues.push(`${label}: FedEx box volume is missing or invalid; verify packaging.`);
      return;
    }
    if (volume > VOLUME_LIMIT) {
      issues.push(`${label}: one wheel exceeds ${VOLUME_LIMIT.toLocaleString('en-US')} in³; review packaging.`);
      return;
    }
    for (let unit = 0; unit < quantity; unit += 1) {
      units.push({ lineId: key, sku: label, volume, unit });
    }
  });
  if (issues.length) return { status: 'incomplete', issues: Array.from(new Set(issues)) };
  units.sort((a, b) => a.volume - b.volume ||
    (a.lineId < b.lineId ? -1 : a.lineId > b.lineId ? 1 : 0) || a.unit - b.unit);

  const boxes = [];
  const assignments = {};
  let low = 0;
  let high = units.length - 1;
  while (low <= high) {
    const contents = [units[high--]];
    // If the smallest cannot fit beside the largest, no other wheel can.
    if (low <= high && contents[0].volume + units[low].volume <= VOLUME_LIMIT) {
      contents.push(units[low++]);
    }
    const boxNumber = boxes.length + 1;
    const lines = [];
    contents.forEach(unit => {
      const existing = lines.find(line => line.lineId === unit.lineId);
      if (existing) existing.quantity += 1;
      else lines.push({ lineId: unit.lineId, sku: unit.sku, quantity: 1 });
      if (!assignments[unit.lineId]) assignments[unit.lineId] = [];
      const assigned = assignments[unit.lineId].find(box => box.boxNumber === boxNumber);
      if (assigned) assigned.quantity += 1;
      else assignments[unit.lineId].push({ boxNumber, quantity: 1 });
    });
    boxes.push({
      boxNumber,
      volume: contents.reduce((sum, unit) => sum + unit.volume, 0),
      lines
    });
  }
  return {
    status: units.length ? 'ready' : 'empty',
    boxes,
    assignments,
    oversize: boxes.length > Math.ceil(units.length / 2),
    threshold: VOLUME_LIMIT
  };
}

module.exports = { buildApexBoxingPlan, VOLUME_LIMIT };
*/
